import { useEffect, useState } from "preact/compat";
import { CaretDownOutlined } from "@ant-design/icons";
import CountryPhoneInput, { ConfigProvider } from "antd-country-phone-input";
import en from "world_countries_lists/data/countries/en/world.json";

const LANGUAGES_MAP = {
  ru: "RU",
  en: "US",
  tr: "TR",
  es: "ES",
};

export const PhoneInput = ({ language, className, onChange }) => {
  const [value, setValue] = useState({ short: "RU" });

  const triggerChange = (changedValue) => {
    onChange(changedValue);
  };

  useEffect(() => {
    if (language) {
      setValue({ short: LANGUAGES_MAP[language] });
    }
  }, [language]);

  return (
    <ConfigProvider locale={en}>
      <CountryPhoneInput
        selectProps={{
          suffixIcon: <CaretDownOutlined />
        }}
        className={className}
        type="tel"
        value={value}
        onChange={(v) => {
          setValue(v);

          triggerChange({
            phone: `+${v.code} ${v.phone}`,
            number: v.phone,
            countryCode: v.short,
          });
        }}
      />
    </ConfigProvider>
  );
};
